import React from "react";
import { CtaButton } from "./CtaButton";
import { SectionHeading } from "./SectionHeading";
import { resources } from "../data/page";
import { PRICE } from "../data/offer";
export function ResourcesSection() {
  return <section className="bg-white px-4 py-16 sm:px-6 sm:py-24" data-id="element-286" data-mp="ngnie3ms4wqn">
      <div className="mx-auto max-w-6xl" data-id="element-287" data-mp="ij5ggx76jhs5">
        <SectionHeading title="You'll also receive practical assessment and documentation resources" subtitle="Beyond the six volumes, I included supplementary materials to help you review the concepts and organize your learning." data-id="element-288" data-mp="iidm1ppbjq3g" />

        <ul className="mt-12 grid gap-x-10 gap-y-10 sm:grid-cols-2 lg:grid-cols-3" data-id="element-289" data-mp="3thio5y7j196">
          {resources.map(({
          icon: Icon,
          title,
          text
        }) => <li key={title} data-id="element-290" data-mp="3vzmpy39avk62">
              <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-accent text-navy-950" data-id="element-291" data-mp="3qyp7dpkdoo41">
                <Icon className="h-7 w-7" aria-hidden="true" data-id="element-292" data-mp="3lzvqro9sogzn" />
              </span>
              <h3 className="mt-4 text-xl font-bold leading-snug text-ink" data-id="element-293" data-mp="1nejlnh1eloko">{title}</h3>
              <p className="mt-2 text-base leading-relaxed text-ink-soft" data-id="element-294" data-mp="1ncozy0ib5sfj">{text}</p>
            </li>)}
        </ul>

        <p className="mx-auto mt-12 max-w-2xl text-center text-lg font-semibold text-ink" data-id="element-295" data-mp="1ee3m2ins71l3">
          The goal is simple: bring the educational references and practical review tools together in one organized
          collection.
        </p>

        <div className="mt-10" data-id="element-296" data-mp="273ty8m5urtek">
          <CtaButton label={`Get instant access — $${PRICE}`} data-id="element-297" data-mp="270oc9fsit7n2" />
        </div>
      </div>
    </section>;
}